import AppConfig from "@/constants/AppConfig";
import { getAuthServiceInstance } from "@/helpers/authService";
import httpStatus from "http-status";

async function getHeaders( { authService, headers, } ) {
	const token = await authService.getIdToken();

	const _headers = {
		"content-type": "application/json",
		...headers,
	};

	if ( token ) {
		_headers.Authorization = `Bearer ${token}`;
	}

	return _headers;
}

export default function api() {
	const authService = getAuthServiceInstance();
	const baseUri = AppConfig.baseUri;

	async function call( endpoint, params = {}, method = "GET", headers = {} ) {
		let body = null;
		let query = "";
		if ( method !== "GET" ) {
			body = JSON.stringify( params );
		} else {
			const parts = [];
			for ( const k of Object.keys( params ) ) {
				parts.push( `${k}=${encodeURIComponent( params[ k ] )}` );
			}
			query = parts.join( "&" );
		}

		const _headers = await getHeaders( { authService, headers, } );

		const opts = {
			headers: new Headers( _headers ),
			method,
			body,
		};

		const res = await fetch( `${baseUri}${endpoint}?${query}`, opts );
		let json = {};

		if ( res.status === httpStatus.NO_CONTENT ) {
			return json;
		}

		try {
			json = await res.json();
		} catch ( e ) {
			console.log( "Error parsing json response", json );
		}

		if ( res.status >= httpStatus.BAD_REQUEST || ( json && ( json.errorType >= httpStatus.BAD_REQUEST || json.errorMessage ) ) ) {
			const e = new Error( json.error || json.message || json.errorMessage || res.statusText );
			e.code = ( json && json.errorType ) || res.status;
			throw e;
		}
		return json;
	}

	function get( endpoint, params = {}, options ) {
		return call( endpoint, params, "GET", options );
	}
	function post( endpoint, params = {}, options ) {
		return call( endpoint, params, "POST", options );
	}
	function put( endpoint, params = {}, options ) {
		return call( endpoint, params, "PUT", options );
	}
	function del( endpoint, params = {}, options ) {
		return call( endpoint, params, "DELETE", options );
	}

	window.__TEAMINGAPI__ = {
		...( window.__TEAMINGAPI__ || {} ),
		call,
		get,
		put,
		del,
		post,
	};

	return { call, get, put, del, post, };
}



// WEBPACK FOOTER //
// ./src/helpers/api.js